export default __webpack_public_path__ + "static/media/Lower_lake_Bhopal.933fd6f5.jpg";